import ArrowDown from "@/assets/icons/chevron_down.svg?react";
import ArrowUp from "@/assets/icons/chevron_up.svg?react";
import { Project } from "@/types/project";
import { blue } from "@/utils/Colors";
import {
  Collapse,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SideBarProjectContent from "./SideBarProjectContent";

interface NavItemLvlTwoProps {
  project: Project;

  pathsToHighlight: string[];
  handleClickArrow: (projectId: string) => void;
  children?: React.ReactNode;
  openSections: Set<string>;
}
export default function NavItemLvlTwo(props: Readonly<NavItemLvlTwoProps>) {
  const navigate = useNavigate();
  const location = useLocation();
  const [hovered, setHovered] = useState(false);

  const shouldBeHighlighted =
    location.pathname.includes(props.project.id) &&
    !location.pathname.includes(`${props.project.id}/`);

  return (
    <>
      <ListItem disablePadding sx={{ display: "flex" }}>
        <ListItemButton
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
          sx={{
            display: "flex",
            flexDirection: "row",
            borderRadius: 1,
            padding: 1,
            gap: 1,
            ...(shouldBeHighlighted && {
              backgroundColor: blue[200],
              color: blue[800],
            }),
            "&:hover": { backgroundColor: blue[300], color: blue[600] },
          }}
          onClick={() => {
            props.handleClickArrow(props.project.id);
            navigate(`/project/${props.project.id}`);
          }}
        >
          <ListItemText
            primary={props.project.name}
            primaryTypographyProps={{
              variant: "subtitle1",
              sx: {
                margin: 0,
                whiteSpace: "nowrap",
                overflowX: "hidden",
                textOverflow: "ellipsis",
                ...(shouldBeHighlighted && {
                  color: blue[800],
                }),
                ...(hovered && {
                  color: blue[600],
                }),
              },
            }}
          />

          {props.openSections.has(props.project.id) ? (
            <ArrowUp
              onClick={(event) => {
                event.stopPropagation();
                props.handleClickArrow(props.project.id);
              }}
            />
          ) : (
            <ArrowDown
              onClick={(event) => {
                event.stopPropagation();
                props.handleClickArrow(props.project.id);
              }}
            />
          )}
        </ListItemButton>
      </ListItem>
      {/* RequestList */}
      <Collapse
        in={props.openSections.has(props.project.id)}
        timeout="auto"
        unmountOnExit
        mountOnEnter
      >
        <SideBarProjectContent
          projectId={props.project.id}
          openSections={props.openSections}
        />
      </Collapse>
    </>
  );
}
